import styled from 'styled-components';

export const H2 = styled.span`
	${({ theme }) => theme.typography.headlines.h2}
	margin: 0 0 16px 0;
	color: ${({ theme }) => theme.colors.primary.medium};
`;

export const H2Container = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
`;

export const H2Decorator = styled.div`
	width: 90px;
	height: 4px;
	background-color: ${({ theme }) => theme.colors.primary.medium};
	position: relative;

	@keyframes move {
		0% {
			transform: translateX(-1px);
		}

		50% {
			transform: translateX(75px);
		}

		100% {
			transform: translateX(-1px);
		}
	}

	&:after {
		content: '';
		position: absolute;
		left: 0;
		top: -1px;
		height: 6px;
		width: 15px;
		border-radius: 0;
		background-color: ${({ theme }) => theme.colors.neutral.white};
		animation: move 5s infinite linear;
	}
`;

export const H5 = styled.div`
	${({ theme }) => theme.typography.headlines.h5}
	position: relative;
	padding-bottom: 10px;
	margin-bottom: 16px;

	&:before {
		position: absolute;
		content: '';
		width: 30px;
		border-bottom: 3px solid ${({ theme }) => theme.colors.primary.medium};
		bottom: 0;
		left: 0;
	}

	&:after {
		position: absolute;
		content: '';
		width: 5px;
		border-bottom: 3px solid ${({ theme }) => theme.colors.primary.medium};
		bottom: 0;
		left: 35px;
	}
`;
